import path from "path";
import { PostFormState } from "./postFormSlice.types";
import { LoadDefaultValuesPayload, PicData } from "./postFormSlice.validators";
import { checkIsFilled } from "./utils/checkIsFilled";

export const loadDefaultValues = (
    state: PostFormState,
    action: { payload: LoadDefaultValuesPayload }
) => {
    const { payload } = action;

    if (payload.brand) {
        state.selectedBrand = {
            id: payload.brandUuid || "",
            name: payload.brand || ""
        };
    }

    if (payload.model) {
        state.selectedModel = {
            id: payload.modelUuid || "",
            name: payload.model || ""
        };
    }

    if (state.selectedBrand && state.selectedModel) {
        state.autoFilled = true;
    }

    if (payload.generationUuid) {
        state.selectedGeneration = {
            id: payload.generationUuid || "",
            name: payload.generationName || ""
        };
    }

    state.selectedYear = action.payload.year;
    state.selectedBodyType = action.payload.body;
    state.selectedEngine = action.payload.engine;
    state.selectedDrive = action.payload.drive;
    state.selectedTransmission = action.payload.transmission;
    state.selectedWheel = action.payload.wheel;
    state.horsePower = action.payload.horsePower;
    state.selectedColor = action.payload.color;
    state.selectedMileage = action.payload.mileage;
    state.vin = action.payload.vin;

    if (
        state.selectedYear &&
        state.selectedBodyType &&
        state.selectedGeneration &&
        state.selectedEngine &&
        state.selectedDrive &&
        state.selectedColor &&
        state.selectedMileage
    ) {
        state.characteristicsFilled = true;
    }

    state.selectedDescription = action.payload.description;
    state.selectedOwnersQnt = action.payload.ownersQnt;

    if (state.selectedDescription && state.selectedOwnersQnt) {
        state.descriptionFilled = true;
    }

    state.selectedSellerType = action.payload.sellerType || "individual";
    state.selectedName = action.payload.contact;
    state.selectedPhone = action.payload.phone;

    if (state.selectedSellerType && state.selectedName && state.selectedPhone) {
        state.contactsFilled = true;
    }

    state.selectedPrice = action.payload.price;
    if (state.selectedPrice) {
        state.priceFilled = true;
    }

    state.selectedCity = action.payload.city;
    state.selectedCountry = action.payload.country;
    state.selectedStreet = action.payload.address;
    if (state.selectedCity && state.selectedCountry) {
        state.placeFilled = true;
    }

    state.selectedPics = action.payload.pics.map((el: PicData) => {
        const url = el.bigUrl || el.url;
        return {
            url: url,
            filename: path.parse(url).base
        };
    });

    state.isFilled = checkIsFilled(state);
};